import { createSlice } from "@reduxjs/toolkit";

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    wishlistItems: [],
  },
  reducers: {
    initializeWishlist: (state, action) => {
      const wishlist = action.payload || [];

      const itemIds = wishlist
        .map(
          (item) =>
            item?.master_product?.id ||
            item?.broken_product?.id ||
            item.auction_id ||
            item.id ||
            item._id ||
            item.item_id
        )
        .filter(Boolean);
      state.wishlistItems = [...itemIds];
    },

    toggleWishlistItem: (state, action) => {
      const itemId = action.payload;
      const index = state.wishlistItems.indexOf(itemId);
      if (index > -1) {
        state.wishlistItems.splice(index, 1);
      } else {
        state.wishlistItems.push(itemId);
      }
    },

    setWishlistItem: (state, action) => {
      const { itemId, isWishlisted } = action.payload;
      const index = state.wishlistItems.indexOf(itemId);
      if (isWishlisted) {
        if (index === -1) {
          state.wishlistItems.push(itemId);
        }
      } else {
        if (index > -1) {
          state.wishlistItems.splice(index, 1);
        }
      }
    },

    clearWishlist: (state) => {
      state.wishlistItems = [];
    },
  },
});

export const {
  initializeWishlist,
  toggleWishlistItem,
  setWishlistItem,
  clearWishlist,
} = favoritesSlice.actions;

export const selectIsWishlisted = (state, itemId) => {
  if (!itemId) return false;
  return state.favorites.wishlistItems.includes(itemId);
};

export const clearFavorites = clearWishlist;
export const initializeWishlistedItems = initializeWishlist;
export const toggleWishlistedItem = toggleWishlistItem;
export const setWishlistedItem = setWishlistItem;
export const selectIsLiked = selectIsWishlisted;

export default favoritesSlice.reducer;
